import { Box, SvgIconProps, SxProps, Theme } from '@mui/material';
import { ControlPosition } from 'shared/map-exports';
import { useTranslation } from 'react-i18next';
import { useMapGLController } from 'features/mapping/hooks/useMapGLController/useMapGLController';
import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { TimelinePlayIcon } from 'features/mapping/components/controls/TimelineModeControl/TimelinePlayIcon';
import { RadarIcon } from './RadarIcon';
import { MapControlButton } from '../MapControlButton';
import {
  BaseMapboxGLController,
  BaseMapboxGLControllerProps,
} from '../BaseMapboxGLController';

type TimelineModeControlProps = {
  onToggle: () => void;
  position?: ControlPosition;
  sx?: SxProps<Theme>;
};

type TimelineModeControlContentProps = {
  onToggle: () => void;
  Icon: (props: SvgIconProps) => JSX.Element;
  sx?: SxProps<Theme>;
};

const TimelineModeControlContent = (
  props: TimelineModeControlContentProps & BaseMapboxGLControllerProps,
): JSX.Element => {
  const { onToggle, Icon, sx } = props;
  const { t } = useTranslation();

  const button = (
    <MapControlButton
      text={t('map.controls.radar')}
      onClick={onToggle}
      Icon={Icon}
    />
  );

  if (sx) {
    return <Box sx={sx}>{button}</Box>;
  }

  return button;
};

class MapboxGLTimelineModeController extends BaseMapboxGLController<
  TimelineModeControlContentProps & BaseMapboxGLControllerProps
> {
  content = (): JSX.Element => <TimelineModeControlContent {...this.props} />;
}

export const TimelineModeControl = ({
  onToggle,
  position = 'top-right',
  sx,
}: TimelineModeControlProps): null => {
  const isTimelineLayersEnabled = useReleaseFlag(
    'show_timeline_layers_in_frontend',
  );

  useMapGLController(
    {
      onToggle,
      Icon: isTimelineLayersEnabled ? TimelinePlayIcon : RadarIcon,
      sx,
      position,
    },
    MapboxGLTimelineModeController,
  );

  return null;
};
